/* globals Promise */

(function () {
  'use strict'

  // Establish the root object ('window' in the browser)
  const root = this

  let googleMapsPromise

  /**
	 *
	 * @returns {boolean}
	 */
  const isGoogleMapsAvailable = function isGoogleMapsAvailable() {
    return Boolean(root.google && root.google.maps && root.google.maps.Geocoder)
  }

  root.isGoogleMapsAvailable = isGoogleMapsAvailable

  /**
	 *
	 * @returns {Promise}
	 */
  const loadGoogleMaps = function loadGoogleMaps() {
    if (!googleMapsPromise) {
      googleMapsPromise = new Promise((resolve, reject) => {
        if (isGoogleMapsAvailable()) {
          resolve()
        } else {
          $.ajax({
            url: 'https://maps.google.com/maps/api/js',
            dataType: 'script',
            data: {
              key: root.ZG_CONFIG.googleMapsApiKey,
              libraries: 'places'
            },
            cache: false, // always load latest version
            success: resolve,
            error() {
              reject(new Error('Google Maps API missing'))
            }
          })
        }
      })
    }

    return googleMapsPromise
  }

  root.loadGoogleMaps = loadGoogleMaps
}).call(this)
